// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'
import RichTextBlock from '../../ev-rich-text-block'
import { Icon } from '../../../atoms'
import { useEntities } from '../../helpers/selectors'
import StatSnippet from '../stat-snippet'
import { removeWhitespaceAndSpecialChars } from '../../helpers/commons'
import { richTextBlockStyleByBrand, moneyQuoteStyles, uswitchQuoteStyles } from './styles'

const SingleColumnRichText = (props) => {
  const { content: document, heading = undefined, brand, name } = props
  let richBlock = document
  let blockquote
  let statSnipet
  if (document) {
    const { content } = document
    let newContent = JSON.parse(JSON.stringify(content))

    blockquote = content
      .slice()
      .reverse()
      .find((c) => c.nodeType === 'blockquote')

    if (blockquote) {
      newContent = newContent.filter((c) => c.nodeType !== 'blockquote')
    }

    const embededEntries = content.filter((c) => c.nodeType === 'embedded-entry-block')
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const entries = useEntities(embededEntries.map((e) => e.data.target))
    statSnipet = entries.find((c) => c.variant === 'stat-snippet')

    if (statSnipet) {
      newContent = newContent.filter((c) => c?.data?.target?.sys?.id !== statSnipet.sys.id)
    }

    richBlock = { ...document, content: newContent }
  }

  return (
    <div className='SingleColumnRichTextNew' id={removeWhitespaceAndSpecialChars(name)}>
      {heading && (
        <RichTextBlock {...props} content={heading} style={richTextBlockStyleByBrand(brand)} />
      )}
      {richBlock && (
        <div className='SingleColumnRichTextNew__container'>
          <div className='SingleColumnRichTextNew__container__columnOne'>
            <RichTextBlock
              {...props}
              content={richBlock}
              style={richTextBlockStyleByBrand(brand)}
            />
          </div>
          <div className='SingleColumnRichTextNew__container__columnTwo'>
            {(blockquote || statSnipet) && (
              <div>
                {blockquote && (
                  <div className='SingleColumnRichTextNew__container__columnTwo__quote'>
                    <div>
                      <Icon
                        glyph={'quotemarks-stroke'}
                        size={45}
                        desktopSize={65}
                        color='#34454E'
                      />
                      <RichTextBlock
                        {...props}
                        content={blockquote}
                        style={brand === 'money' ? moneyQuoteStyles : uswitchQuoteStyles}
                      />
                    </div>
                  </div>
                )}
                {statSnipet && <StatSnippet {...statSnipet} />}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default SingleColumnRichText
